import React from 'react';
import styled from 'styled-components';
import Button from 'components/_UI/Button';
import Modal from 'components/_UI/Modal';
import Text from 'components/_UI/Text';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import { enterProducerPanel } from './enterProducerPanel';

/**
 * Quem foi convidado por equipes de mais de um produtor escolhe em qual
 * painel entrar.
 */
export default function ProducerPanelPicker({ visible, accesses, onClose }) {
    return (
        <Modal isOpen={!!visible} closeButton={true} onClose={onClose}>
            <Text name='subtitle' type='bold' color={colors.nightDark}>
                Escolha o painel
            </Text>

            <Text color={colors.night} marginTop={'4px'}>
                Você faz parte de equipes de mais de um produtor.
            </Text>

            <Options>
                {accesses.map((access) => (
                    <Option key={access.producer_id}>
                        <Column>
                            <Text type='bold' color={colors.nightDark} paddingBottom={0}>
                                {access.name}
                            </Text>
                            <Text color={colors.nightLight} paddingBottom={0}>
                                {access.teams.map((team) => team.name).join(', ')}
                            </Text>
                        </Column>

                        <Button
                            variant='lightBlue'
                            category='roundedBorded'
                            onClick={() => enterProducerPanel(access)}
                        >
                            Entrar
                        </Button>
                    </Option>
                ))}
            </Options>
        </Modal>
    );
}

const Options = styled(Column)`
    margin-top: 16px;
    gap: 10px;
`;

const Option = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid ${colors.night}22;
    border-radius: 10px;
`;
